import { useSettingsStore } from '@/store/settings'
import { OrgSettingName } from '@/types/organization'

export const useSetting = (name: OrgSettingName) => {
  const settings = useSettingsStore(state => state.settings)
  return settings[name]
}
